import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchPhysicalConnections({ commit }, obj) {
    return new Promise((resolve, reject) => {
      API.splicing.getPhysicalConnections(
        obj,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  addRack({ commit }, obj) {
    return new Promise((resolve, reject) => {
      API.splicing.createRack(
        obj,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  updateRack({ commit }, obj) {
    return new Promise((resolve, reject) => {
      API.splicing.editRack(
        obj,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  removeRack({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.splicing.removeRack(
        uuid,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  createDrawer({ commit }, obj) {
    return new Promise((resolve, reject) => {
      API.splicing.createDrawer(
        obj,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  updateDrawer({ commit }, obj) {
    return new Promise((resolve, reject) => {
      API.splicing.updateDrawer(
        obj,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  removeDrawer({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.splicing.removeDrawer(
        uuid,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  getObjectFiberConnections({ commit }, { objectEndpoint, objectUUID }) {
    return new Promise((resolve, reject) => {
      API.splicing.getObjectFiberConnections(
        objectEndpoint,
        objectUUID,
        result => {
          let connections = result.data.data;
          resolve(connections);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchObjectSplicingConnections({ commit }, { objectEndpoint, objectUUID }) {
    return new Promise((resolve, reject) => {
      API.splicing.getSplicingConnections(
        objectEndpoint,
        objectUUID,
        result => {
          let connections = result.data.data;
          resolve(connections);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  updateObjectSplicingConnections(
    { commit },
    { objectEndpoint, objectUUID, updatedConnections }
  ) {
    return new Promise((resolve, reject) => {
      API.splicing.updateSplicingConnections(
        objectEndpoint,
        objectUUID,
        updatedConnections,
        result => {
          let connections = result.data.data;
          resolve(connections);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  saveObjectSplicingConnections(
    { commit },
    { objectEndpoint, objectUUID, updatedConnections }
  ) {
    return new Promise((resolve, reject) => {
      API.splicing.saveSplicingConnections(
        objectEndpoint,
        objectUUID,
        updatedConnections,
        result => {
          let connections = result.data.data;
          resolve(connections);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchFiberCircuitByUuid({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.splicing.getFiberCircuitByUuid(
        uuid,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchClosureCassettes({ commit }, filter = null) {
    return new Promise((resolve, reject) => {
      API.splicing.getClosureCassettes(
        filter,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editFibers({ commit }, fibersData) {
    return new Promise((resolve, reject) => {
      API.splicing.editFibers(
        fibersData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  createCassette({ commit }, cassetteData) {
    return new Promise((resolve, reject) => {
      API.splicing.createCassette(
        cassetteData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      )
    })
  },

  editCassette({ commit }, cassetteData) {
    return new Promise((resolve, reject) => {
      API.splicing.editCassette(
        cassetteData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      )
    })
  },

  deleteCassette({ commit }, cassetteUuid) {
    return new Promise((resolve, reject) => {
      API.splicing.deleteCassette(
        cassetteUuid,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      )
    })
  },
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Home/splicing.js